import type { ErrorStore } from '../../types/error-context';
import { useErrorStore } from '../use-error-store/use-error-store';

export const useErrorContext = (): ErrorStore => {
  return useErrorStore((store) => store);
};
